import moment from "moment/moment";
import {DateFormats} from "../../constants/securspace-constants";
import request from "../../../util/SuperagentUtils";
import {supplierPayoutReportEndpoints} from "../../../requests/api-endpoints";

const getPayoutsUrlParams = (requestParams, isPageable) => {

    const params = isPageable ? new URLSearchParams([["page", requestParams?.page || 0], ["size", requestParams?.pageSize || 10]]) : new URLSearchParams();

    if (requestParams?.startDate) {
        params.append("startDate", moment(requestParams?.startDate).format(DateFormats.DAY));
    }
    if (requestParams?.endDate) {
        params.append("endDate", moment(requestParams?.endDate).format(DateFormats.DAY));
    }
    if (requestParams?.locationId) {
        params.append("locationId", requestParams?.locationId)
    }
    if (requestParams?.status) {
        params.append("status", requestParams?.status)
    }
    if (requestParams?.payoutCompleted) {
        params.append("payoutCompleted", (requestParams?.payoutCompleted == 'true') ? 'true' : 'false')
    }
    if (requestParams?.sortBy) {
        params.append("sortBy", requestParams?.sortBy)
    }
    if (requestParams?.sortDir) {
        params.append("sortDir", requestParams?.sortDir)
    }

    return params;
}

export const requestPayoutsPaginated = (searchParams,
                                                onSuccess,
    onFail) => {

    const result = request.get(`${supplierPayoutReportEndpoints.search}?${getPayoutsUrlParams(searchParams, true)}`);

    if(onSuccess && onFail) {
        result
            .then(onSuccess)
            .catch(onFail)
    } else {
        return result
    }
}

export const getPayoutsReportUrl = (searchParams) => {
    return `${supplierPayoutReportEndpoints.report}?${getPayoutsUrlParams(searchParams, false)}`;
}

export const getPayoutsGroupSummaryUrl = (searchParams) => {
    let summaryParams = {
        startDate: searchParams.startDate,
        endDate: searchParams.endDate,
        locationId: searchParams.locationId
    }

    return `${supplierPayoutReportEndpoints.group}?${getPayoutsUrlParams(summaryParams, false)}`;
}

export const requestCalculatePayoutsSummary = async (searchParams) => {
    return await request.get(`${supplierPayoutReportEndpoints.summary}?${getPayoutsUrlParams(searchParams, false)}`);
}
